export class DspAppConfig {
  constructor(
    public geonameToken: string,
    public iriBase: string
  ) {}
}
